"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const form_1 = __importDefault(require("antd/lib/form"));
const recoil_1 = require("recoil");
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const react_i18next_1 = require("react-i18next");
const FoldersTree_1 = __importStar(require("../FoldersPage/FoldersTree"));
const CustomModal_1 = __importDefault(require("./CustomModal"));
const core_1 = require("@material-ui/core");
const components_1 = require("@alcumus/components");
const Toast_1 = require("../Toast/Toast");
const useStyles = (0, core_1.makeStyles)(() => ({
    headerText: {
        fontWeight: 'normal',
        color: components_1.StyleVariables.colors.text.default,
    },
    divText: {
        fontWeight: 'normal',
        color: components_1.StyleVariables.colors.text.default,
    },
    mandatoryText: {
        color: components_1.StyleVariables.colors.text.critical,
        marginLeft: '5px',
    },
    successModal: {
        backgroundColor: components_1.StyleVariables.colors.surface.neutral.default,
        borderRadius: '6px',
        border: `1px solid ${components_1.StyleVariables.colors.border.default}`,
        fontWeight: 400,
        borderLeft: `8px solid ${components_1.StyleVariables.colors.text.success}`,
    },
    iconColor: {
        color: `${components_1.StyleVariables.colors.text.success}`,
    },
}));
const MoveToFolderModal = ({ id, dashboardName, formSubmitCallback, successCallback, successMessage, failureMessage, errorMessage, titleValidationCallback, currentFolderName, duplicateErrorMessage, headerText, primaryButtonText, visible, setVisible, t, }) => {
    const [isFormSubmitting, setIsFormSubmitting] = (0, react_1.useState)(false);
    const [selectedFolderNode, setSelectedFolder] = (0, recoil_1.useRecoilState)(FoldersTree_1.selectedFolderState);
    const [, setTitle] = (0, react_1.useState)();
    const isMounted = (0, react_1.useRef)(true);
    const [form] = form_1.default.useForm();
    const classes = useStyles();
    const [toastProps, setToastProps] = (0, recoil_1.useRecoilState)(Toast_1.showToastState);
    const validateTitleUniqueness = async () => {
        if (isFormSubmitting) {
            const isTitleUnique = await titleValidationCallback();
            if (!isTitleUnique) {
                setIsFormSubmitting(false);
                return Promise.reject(duplicateErrorMessage);
            }
            return Promise.resolve();
        }
    };
    const handleFormSubmit = async () => {
        setIsFormSubmitting(true);
        validateTitleUniqueness();
        const selectedFolder = selectedFolderNode?.value;
        formSubmitCallback(selectedFolder)
            .then((result) => {
            resetModal();
            if (successCallback && (0, isFunction_1.default)(successCallback))
                successCallback(result);
            return result
                ? setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'success',
                    message: successMessage,
                })
                : setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'error',
                    message: failureMessage,
                });
        })
            .catch((err) => {
            console.log(err);
            setToastProps({
                ...toastProps,
                showToast: true,
                severity: 'error',
                message: errorMessage,
            });
        })
            .finally(() => {
            if (isMounted.current)
                setIsFormSubmitting(false);
        });
    };
    function resetModal() {
        if (isFormSubmitting)
            return;
        form.resetFields();
        setSelectedFolder(undefined);
        setTitle(undefined);
        setVisible(false);
    }
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    });
    return (react_1.default.createElement(CustomModal_1.default, { open: visible, "data-testid": id, headerText: headerText, primaryButtonText: primaryButtonText, disablePrimaryButton: !selectedFolderNode, onHide: resetModal, isValidating: isFormSubmitting, onPrimaryAction: async () => await handleFormSubmit(), modalBody: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes.headerText }, t('dashboard')),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { className: classes.divText }, dashboardName),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { className: classes.headerText }, t('currentFolder')),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { className: classes.divText }, currentFolderName),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { className: classes.headerText }, t('moveTo')),
                react_1.default.createElement("label", { className: classes.mandatoryText }, '*')),
            react_1.default.createElement(FoldersTree_1.default, { visible: visible })) }));
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(MoveToFolderModal);
